
import {isEmpty} from "../utils/commons";
import {submitLogin} from "../apis/security_apis";
import {LOADED_USED_PROFILE} from "./global_store";

export const LOGIN = "login";
export const LOGIN_ON_CHANGE = "loginOnChange";
export const LOGIN_ON_VALIDATE = "loginOnValidate";
const LOGIN_SUBMITTING = "loginSubmitting";
const LOGIN_SUBMITTED = "loginSubmitted";
const RESET_LOGIN = "resetLogin";

const initLoginErrors = () => ({
    email: "",
    password: ""
})

const initState = () => ({
        email: "",
        password: "",
        error: "",
        submitting: false,
        fieldErrors: initLoginErrors(),
})

const state = initState();

const mutations = {
    [LOGIN_ON_CHANGE] (state, payload) {
        Object.assign(state, {[payload.name]:payload.value});
    },
    [LOGIN_ON_VALIDATE] (state, payload) {
        Object.assign(state, {fieldErrors: {...payload}});
    },
    [LOGIN_SUBMITTING] (state) {
        Object.assign(state, {submitting: true, error: ""});
    },
    [LOGIN_SUBMITTED] (state, payload) {
        Object.assign(state, {submitting: false, error: payload.error});
    },
    [RESET_LOGIN] (state) {
        Object.assign(state, initState());
    }
}

const actions = {
    [LOGIN_ON_CHANGE] ({commit}, payload) {
        commit(LOGIN_ON_CHANGE, payload)
    },
    [LOGIN_ON_VALIDATE] ({commit, state}) {
        let errors = {};
        ["email", "password"].forEach( key => {

            if(isEmpty(state[key])) {
                errors[key] = "This field is required";
            }

        });

        commit(LOGIN_ON_VALIDATE, errors);
        if(Object.keys(errors).length > 0) {
            commit(LOGIN_ON_CHANGE, {name: "error", value: "Some fields invalid"});
        }else {
            commit(LOGIN_ON_CHANGE, {name: "error", value: ""});
        }
    },
    [LOGIN] ({commit, state}, callback) {

        commit(LOGIN_SUBMITTING);
        submitLogin({email: state.email, password: state.password})
            .then((results) => {
                    commit(LOGIN_SUBMITTED, {});
                    commit(LOADED_USED_PROFILE, {user: results});
                    commit(RESET_LOGIN);
                    callback();
                },
                (results) => {
                    let error = !results.error? "Login failed.": results.error;
                    commit(LOGIN_SUBMITTED, {info: "", "error": error});
                    callback();
                })


    }
}


export default {
    state,
    mutations,
    actions
}
